import React, { useState, ChangeEvent, useEffect } from 'react';
import { Label } from './DataSector';
import { PrimeService } from '../../Services/PrimeService';
import { ISector, ISectorResponse, IWork } from '../../Models/Sector/ISector';

interface MetierSelectProps {
    language: 'fr' | 'nl';
    onSelectionChange: (selection: { sector: string; work: string }) => void;
}

const SelectSectorWork: React.FC<MetierSelectProps> = ({
    language,
    onSelectionChange,
}) => {
    const [selectedSector, setSelectedSector] = useState<string>('');
    const [selectedWork, setSelectedWork] = useState<string>('');
    const [sectors, setSectors] = useState<ISector[]>([]);
    const [works, setWorks] = useState<IWork[]>([]);

    const labelSector: Label = {
        name: { fr: 'Choisissez un secteur *', nl: 'Kies een sector *' },
    };
    const placeHolderSector: Label = {
        name: {
            fr: '-- Sélectionnez un secteur --',
            nl: '-- Selecteer een sector --',
        },
    };
    const labelWork: Label = {
        name: { fr: 'Choisissez un métier *', nl: 'Kies een beroep *' },
    };
    const placeHolderWork: Label = {
        name: {
            fr: '-- Sélectionnez un métier --',
            nl: '-- Selecteer een beroep --',
        },
    };

    useEffect(() => {
        const getSectors = async () => {
            const structureData: ISectorResponse =
                await PrimeService.GetAllSectors();
            setSectors(structureData.data.secteurs);
        };
        void getSectors();
    }, []);
    const handleSectorChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const sectorId = event.target.value;
        const tmp: ISector | undefined = sectors.find((u) => u.id == sectorId);
        setSelectedSector(sectorId);
        setWorks(tmp && tmp.metiers ? tmp.metiers : []);
        setSelectedWork('');
        onSelectionChange({ sector: sectorId, work: '' });
    };

    const handleWorkChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const workId = event.target.value;
        setSelectedWork(workId);
        onSelectionChange({ sector: selectedSector, work: workId });
    };
    return (
        <div>
            <label
                htmlFor="sectorCompany"
                className={'col-12 mt-3 p-0'}
                style={{ fontSize: '1.2rem' }}
            >
                {labelSector.name[language]}
            </label>
            <select
                id="sectorCompany"
                className={'col-12 col-md-10 mt-2'}
                value={selectedSector}
                onChange={handleSectorChange}
            >
                <option value="">{placeHolderSector.name[language]}</option>
                {sectors.map(
                    (sector) =>
                        sector.metiers.length > 0 && (
                            <option
                                key={sector.id}
                                value={sector.id.toString()}
                            >
                                {language == 'fr' ? sector.nomFR : sector.nomNL}
                            </option>
                        )
                )}
            </select>

            {selectedSector && (
                <>
                    <label
                        htmlFor="workCompany"
                        className={'col-12 mt-3 p-0'}
                        style={{ fontSize: '1.2rem' }}
                    >
                        {labelWork.name[language]}
                    </label>
                    <select
                        id="workCompany"
                        className={'col-12  col-md-10 mt-3'}
                        value={selectedWork}
                        onChange={handleWorkChange}
                    >
                        <option value="">
                            {placeHolderWork.name[language]}
                        </option>
                        {works.map((work) => (
                            <option key={work.id} value={work.id}>
                                {language == 'fr' ? work.nomFR : work.nomNL}
                            </option>
                        ))}
                    </select>
                </>
            )}
        </div>
    );
};

export default SelectSectorWork;
